/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TListProjectHoldingFeesDueResponse } from '../models/TListProjectHoldingFeesDueResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class HoldingFeeService {
    /**
     * List holding fees coming due (or overdue) across a project
     * @param projectId
     * @param withinDays
     * @returns TListProjectHoldingFeesDueResponse TListProjectHoldingFeesDueResponse
     * @throws ApiError
     */
    public static listProjectHoldingFeesDue(
        projectId: string,
        withinDays?: number,
    ): CancelablePromise<TListProjectHoldingFeesDueResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/holding-fees',
            query: {
                'projectId': projectId,
                'withinDays': withinDays,
            },
        });
    }
}
